<template>
  <div class="text-white rounded-xl py-2 mt-2 text-xs text-center bg-red-500">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "VAlert"
}
</script>

<style scoped>

</style>